// ExportToExcel.js
import React from "react";
import { Button } from "react-bootstrap";
import * as XLSX from "xlsx";

// ExportToExcel component
const ExportToExcel = ({ tableRef, filename = "table_data.xlsx" }) => {
  const exportToExcel = () => {
    const table = tableRef.current;
    if (!table) return;

    const ws = XLSX.utils.table_to_sheet(table); // Convert the table to sheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Save as .xlsx file
    XLSX.writeFile(wb, filename);
  };

  return (
    <Button onClick={exportToExcel} variant="info">
        <i className="mdi mdi-file-excel me-1"></i>Excel
    </Button>
  );
};

export default ExportToExcel;
